import { ExcelFields } from 'components/registry/types/api';
import { DraggableLocation } from 'react-beautiful-dnd';

export enum ActionKind {
  MOVE = 'MOVE',
  RIGHT = 'RIGHT',
  LEFT = 'LEFT',
  TEMPLATE = 'TEMPLATE',
}

export type ExportAction = {
  type: ActionKind;
  source?: DraggableLocation;
  destination?: DraggableLocation;
  itemsArray?: ExcelFields[];
  selectedItemsArray?: ExcelFields[];
};

export type ModalForm = {
  check?: boolean;
  templateName?: string;
};
